/**
 * Produktseite: Duftfarbe folgt der Variantenwahl.
 *
 * Setzt `data-venoa-scent` (cherry | pacific | purple) auf <body>. Das CSS
 * blendet damit den Farbschein hinter der Galerie weich über (registrierte
 * Custom Property, 700 ms). <body> statt der Section, weil Dwell die Section
 * beim Variantenwechsel per Morph neu aufbaut und ein Attribut dort verloren
 * ginge. Preis, Verfügbarkeit und Warenkorb laufen unverändert über Dwell –
 * hier wird nichts davon angefasst oder verzögert.
 */
(() => {
  if (window.__venoaPdpScent) return;
  window.__venoaPdpScent = true;

  const KEYS = ['cherry', 'pacific', 'purple'];

  const apply = (title) => {
    const text = String(title || '').toLowerCase();
    const key = KEYS.find((candidate) => text.includes(candidate));
    if (key) {
      document.body.dataset.venoaScent = key;
    } else {
      delete document.body.dataset.venoaScent;
    }
  };

  const checked = () =>
    document.querySelector('.product-information variant-picker input[type="radio"]:checked')?.value;

  apply(checked());

  // Sofort beim Klick – die Radios ändern sich synchron.
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (
      target instanceof HTMLInputElement &&
      target.type === 'radio' &&
      target.closest('.product-information variant-picker')
    ) {
      apply(target.value);
    }
  });

  // Bestätigt, nachdem Dwell die Duftleiste neu aufgebaut hat (Dwell 4.1.5:
  // Standard-Event „shopify:product:select“, dessen promise nach dem Umbau
  // aufgelöst wird; das frühere „variant:update“ gibt es nicht mehr).
  // Nur, wenn es noch zur aktuellen Auswahl passt: bei schnellen Wechseln gilt die letzte.
  document.addEventListener('shopify:product:select', (event) => {
    const promise = /** @type {any} */ (event).promise;
    if (!promise || typeof promise.then !== 'function') return;
    promise
      .then((result) => {
        const title = result?.detail?.resource?.title;
        if (title && title === checked()) apply(title);
      })
      .catch(() => {});
  });
})();
